/**
 * Reads a CSV export (RFC 4180: quoted fields, doubled quotes, newlines inside quotes; comma or
 * semicolon separated) into one object per row keyed by the header row. Blank lines are skipped.
 */
export function parseCsv(text) {
    const src = text.replace(/^﻿/, '');
    const firstLine = src.slice(0, src.indexOf('\n') < 0 ? undefined : src.indexOf('\n'));
    const sep = (firstLine.match(/;/g)?.length ?? 0) > (firstLine.match(/,/g)?.length ?? 0) ? ';' : ',';
    const records = [];
    let row = [];
    let field = '';
    let quoted = false;
    for (let i = 0; i < src.length; i++) {
        const c = src[i];
        if (quoted) {
            if (c === '"' && src[i + 1] === '"') {
                field += '"';
                i++;
            }
            else if (c === '"')
                quoted = false;
            else
                field += c;
        }
        else if (c === '"')
            quoted = true;
        else if (c === sep) {
            row.push(field);
            field = '';
        }
        else if (c === '\n' || c === '\r') {
            if (c === '\r' && src[i + 1] === '\n')
                i++;
            row.push(field);
            field = '';
            if (row.some((f) => f.trim()))
                records.push(row);
            row = [];
        }
        else
            field += c;
    }
    row.push(field);
    if (row.some((f) => f.trim()))
        records.push(row);
    const headers = (records.shift() ?? []).map((h) => h.trim());
    const rows = records.map((r) => Object.fromEntries(headers.map((h, i) => [h, (r[i] ?? '').trim()])));
    return { headers, rows };
}
//# sourceMappingURL=csv.js.map